import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getGuestSessionSnapshot,
  LANDING_AUTH_EVENT,
} from './landingAuth';

/**
 * Keeps Join-page "Verified" UI in sync when Get Started / drawer
 * clears or replaces the landing session without remounting this page.
 */
export function useGuestSession() {
  const location = useLocation();
  const [session, setSession] = useState(() => getGuestSessionSnapshot());

  const refresh = useCallback(() => {
    setSession(getGuestSessionSnapshot());
  }, []);

  useEffect(() => {
    refresh();
  }, [location.pathname, location.key, refresh]);

  useEffect(() => {
    const onAuth = () => refresh();
    const onFocus = () => refresh();
    const onStorage = (e) => {
      if (
        !e.key ||
        e.key === 'access-token' ||
        e.key === 'role' ||
        e.key === 'mobile'
      ) {
        refresh();
      }
    };
    window.addEventListener(LANDING_AUTH_EVENT, onAuth);
    window.addEventListener('focus', onFocus);
    window.addEventListener('storage', onStorage);
    document.addEventListener('visibilitychange', onAuth);
    return () => {
      window.removeEventListener(LANDING_AUTH_EVENT, onAuth);
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('storage', onStorage);
      document.removeEventListener('visibilitychange', onAuth);
    };
  }, [refresh]);

  return { ...session, refresh };
}
